exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio-wrap[data-v-6592a3bb]{padding:20px;background:#fff;border:1px solid #f0f0f0;border-radius:4px}", ""]);

// exports
